import MuiIconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import React from 'react';

const PREFIX = 'Icon';

const classes = {
  icon: `${PREFIX}-icon`
};

const StyledMuiIconButton = styled(MuiIconButton)({
  [`&.${classes.icon}`]: { color: 'white', cursor: 'pointer', float: 'right', marginTop: '0px' }
});
export interface IconProps {
  bgColor?: string;
  url?: string;
  element?: JSX.Element;
}
export default function Icon({ bgColor, element, url }: IconProps) {
  return (
    <StyledMuiIconButton
      className={classes.icon}
      size="small"
      style={{ backgroundColor: bgColor }}
      onClick={() => {
        window.open(url);
      }}
    >
      {element}
    </StyledMuiIconButton>
  );
}
